<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10KubTh/tc-custom/9781479846771.jpg?1719927336154" alt="This image is the cover for the book Defiant"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Defiant
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In the tradition of Howard Zinn’s A People’s History of the United States, an engaging account of the last half-century of political discontent <br/></b><br/>The history of the United States is a history of oppression and inequality, as well as raucous opposition to the status quo. It is a history of slavery and child labor, but also the protest movements that helped end those institutions. Protesters have been the driving force of American democracy, from the expansion of voting rights and the end of segregation laws, to minimum wage standards and marriage equality.<br/><br/>In this exceptional new book, Dawson Barrett calls our attention to the post-1960s period, in which US economic, cultural, and political elites turned the tide against the protest movement gains of the previous forty years and reshaped the ability of activists to influence the political process.<br/><br/>For much of the last half-century, policymakers in both major US political parties have been guided by the “pro-business” tenets of neoliberalism. Dubbed “casino capitalism” by its critics, this economy has ravaged the environment, expanded the for-profit war and prison industries, and built a global assembly line rooted in sweatshop labor, while more than doubling the share of American wealth and income held by the country’s richest 1 percent. <br/><br/>The Defiant explores the major policy shifts of this new Gilded Age through the lens of dissent—through the picket lines, protest marches, and sit-ins that greeted them at every turn. Barrett documents these clashes at neoliberalism’s many points of impact, moving from the Arizona wilderness, to Florida tomato fields, to punk rock clubs in New York and California—and beyond. He takes readers right up to the present day with an epilogue tracing the Trump administration’s strategies and policy proposals, and the myriad protests they have sparked. <br/><br/>Capturing a wide range of protest movements in action—from environmentalists’ tree-sits to Iraq War peace marches to Occupy Wall Street, #BlackLivesMatter, and more—The Defiant is a gripping analysis of the profound struggles of our times.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dawson Barrett
      </h2>
      
      <p class="authorDescription body article"><B>Dawson Barrett</B> is Asscoiate Professor of US History at Del Mar College in Texas. He is the author of <I>Teenage Rebels: Successful High School Activists, from the Little Rock Nine to the Class of Tomorrow</I> (Microcosm Publishing, 2015) and <I>The Defiant: Protest Movements in Post-Liberal America</I> (NYU Press, 2018).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?173a3f28